import {
  TOOGLE_SIDEBAR,
  TOOGLE_LOADING,
} from './app.actions';

const initialState = {
  loading: false,
  sidebarShow: !((window.innerWidth <= 760)),
};

export default (state = initialState, { type }) => {
  switch (type) {
    case TOOGLE_SIDEBAR: {
      return {
        ...state,
        sidebarShow: !state.sidebarShow,
      };
    }
    case TOOGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    default:
      return state;
  }
};
